// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';

import MBTextField from 'components/Forms/MBTextField/MBTextField';
import { SearchIcon as MuiSearchIcon, CloseIcon as MuiCloseIcon } from 'icons';
import pxToEm from 'theme/pxToEm';

export const Field = styled(MBTextField)`
  width: 100%;
  display: flex;

  .MuiOutlinedInput-root {
    border-radius: ${pxToEm(24)};
    background-color: ${({ theme }) => theme.palette.grey[50]};
    border-color: ${({ theme }) => theme.palette.grey[50]};
    height: 36px;
    padding-left: 10px;

    &:hover,
    &.Mui-focused {
      .MuiInputAdornment-root:first-of-type svg {
        color: ${({ theme }) => theme.palette.primary.main};
      }
    }

    & fieldset {
      border: none !important;
    }
  }
`;

export const SearchIcon = styled(MuiSearchIcon)`
  width: ${pxToEm(20)};
  color: ${({ theme }) => theme.palette.grey.A400};
  margin-right: ${pxToEm(12.25)};
`;

export const CloseIcon = styled(MuiCloseIcon)`
  cursor: pointer;
  width: ${pxToEm(20)};
  color: ${({ theme }) => theme.palette.grey.A400};
`;
